import { render, staticRenderFns } from "./TaskFormModal.vue?vue&type=template&id=77f0c8f2&scoped=true&"
import script from "./TaskFormModal.vue?vue&type=script&lang=js&"
export * from "./TaskFormModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskFormModal.vue?vue&type=style&index=0&id=77f0c8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f0c8f2",
  null
  
)

export default component.exports